module.exports = require("scroll-to-element");


//////////////////
// WEBPACK FOOTER
// external "scroll-to-element"
// module id = 593
// module chunks = 0